import {FileCheck2} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const FileDownloadDoneIcon = createLucideIcon(FileCheck2, 'FileDownloadDoneIcon');
